/* Plays snippets/video-media.liquid videos only while they are on screen.
   Off-screen ones ship with preload="none", so nothing downloads until play() here;
   videos that scroll away are paused to free the decoder. Inside carousels the
   overflow clip counts, so slides parked off to the side stay idle. */
(function () {
  var seen = new WeakSet();
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function scan(root) {
    (root || document).querySelectorAll('video[data-video-media]').forEach(function (v) {
      if (seen.has(v)) return;
      seen.add(v);
      if (io) io.observe(v);
      else v.play();
    });
  }

  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
